/**
 * Gets an element by id or selector and checks its existence on the page
 * @param elementId The value by which we will try to find the element
 * @returns HTML element or null (if the element was not found on the page)
 */
export var getElement = function (elementId) {
    if (typeof elementId === 'object' && elementId.nodeType && document.body.contains(elementId)) {
        // elementId is HTMLElement
        return elementId;
    }
    if (!elementId || typeof elementId !== 'string') {
        // not an element, not a string -> nothing to return
        return null;
    }
    // search by id
    var elementById = document.getElementById(elementId);
    if (elementById) {
        return elementById;
    }
    // search by selector
    try {
        return document.querySelector(elementId);
    }
    catch (_a) {
        return null;
    }
};
